import getCode from "utils/getRoleCode";

export const COLORS = {
  primarycolor: "#1F1D31",
  secondaryColor: "#43263D",
  edooAqua: "#091D3F",
  bgEdoo: "#DBAC26",
};

export const DEFAULT_TIME_SLIDER = 300000; // milisecond
export const allowedRoles = [
  getCode("SA"),
  getCode("Supervisor"),
  getCode("Admin"),
];
